import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { API_V2 } from '../api.conf';

import {
  InitResetPasswordRequestDTO,
  RefreshTokenRequestDTO,
  SignInRequestDTO,
  SignUpRequestDTO,
  UpdatePasswordRequestDTO,
} from '../../dto/request';
import { RefreshTokenResponseDTO, SignInResponseDTO, SignUpResponseDTO } from '../../dto/response';

@Injectable()
export class AuthApiService {
  constructor(private http: HttpClient, @Inject(API_V2) private api: string) {}

  private get basePath() {
    return `${this.api}/public`;
  }

  signin(companyUuid: string, payload: SignInRequestDTO): Observable<SignInResponseDTO> {
    return this.http.post<SignInResponseDTO>(`${this.basePath}/companies/${companyUuid}/signin`, payload);
  }

  signup(companyUuid: string, payload: SignUpRequestDTO): Observable<SignUpResponseDTO> {
    return this.http.post<SignUpResponseDTO>(`${this.basePath}/companies/${companyUuid}/signup`, payload);
  }

  initResetPassword(companyUuid: string, payload: InitResetPasswordRequestDTO) {
    return this.http.post(`${this.basePath}/companies/${companyUuid}/password/reset`, payload);
  }

  verifyResetPassword(companyUuid: string, token: string) {
    return this.http.get(`${this.basePath}/companies/${companyUuid}/password/reset/${token}`);
  }

  updatePassword(companyUuid: string, token: string, payload: UpdatePasswordRequestDTO) {
    return this.http.post(`${this.basePath}/companies/${companyUuid}/password/reset/${token}`, payload);
  }

  refreshToken(companyUuid: string, payload: RefreshTokenRequestDTO): Observable<RefreshTokenResponseDTO> {
    return this.http.post<RefreshTokenResponseDTO>(`${this.basePath}/companies/${companyUuid}/refreshtoken`, payload);
  }
}
